'use client'

import {useIsGamePage} from '@app/[lang]/(common-header-footer)/content-wrapper/content-wrapper-client'
import {tagPath} from '@app/[lang]/(common-header-footer)/tags/constants'
import {supportedLanguages} from '@app/i18n/settings'
import {usePathname} from 'next/navigation'
import {ReactNode} from 'react'

type Props = {
  children: ReactNode
  host: string | null
}

const StickyFooterVisibilityWrapper = ({children, host}: Props) => {
  const path = usePathname() || ''
  const segments = path.split('/').filter(Boolean)
  const isTagPage = path.includes(`/${tagPath}/`)

  // allowed paths: /, /en, /hi, etc
  const isHomepage =
    path === '/' ||
    (segments.length === 1 && supportedLanguages.includes(segments[0] as (typeof supportedLanguages)[number]))

  if (!(isTagPage || isHomepage)) {
    return null
  }

  return children
}

export default StickyFooterVisibilityWrapper
